export const MuiTypography = {
    body1: {
        fontSize: '0.875rem',
        fontWeight: '400',
    },
    body2: {
        fontSize: '0.825rem',
        fontWeight: '400',
    },
    h1: {
        fontWeight: 700,
        fontSize: '1.625rem',
        letterSpacing: '0px',
    },
    h2: {
        fontWeight: 700,
        fontSize: '1.563rem',
        letterSpacing: '-0.24px',
    },
    h3: {
        fontWeight: 700,
        fontSize: '1.563rem',
        letterSpacing: '0px',
    },
    h4: {
        fontWeight: 500,
        fontSize: '1.125rem',
        letterSpacing: '-0.06px',
    },
    h5: {
        fontWeight: 700,
        fontSize: '1.938rem',
        letterSpacing: '-0.05px',
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: '-0.05px',
    },
    overline: {
        fontWeight: 500,
    },
    subtitle1: {
        fontSize: '0.75rem',
    },
    subtitle2: {
        fontSize: '0.875rem',
    },
    caption: { fontSize: '0.875rem', fontWeight: 700 },
    fontFamily: [
        'Open Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
};
